<div
    #selectContainer
    class="custom-select z-20">
    @if (label()) {
        <label class="text-base">{{ label() }}</label>
    }
    <div
        class="input-div relative px-3 h-12 flex flex-row justify-between flex-nowrap items-center rounded-lg"
        id="select-div"
        (click)="toggleSelect()">
        @if (!isOpen() && selectedOption()) {
            <p
                class="truncated !m-0 text-base"
                id="selected-option">
                @for (labelWithStyle of selectedOption()!.labelsWithStyle; track labelWithStyle.label) {
                    <span
                        class="px-2"
                        [style]="{
                            'background-color': labelWithStyle.color,
                            border: !!labelWithStyle.color ? '1px solid #000000' : '',
                            'border-radius': '0.75rem',
                            color: labelWithStyle.font,
                        }">
                        {{ labelWithStyle.label }}</span
                    >
                    @if (!$last) {
                        |
                    }
                }
            </p>
        } @else {
            <input
                #selectInput
                autocomplete="off"
                class="rounded-lg bg-transparent w-full h-full border-none focus:outline-none text-base"
                id="select-input"
                type="text"
                [autofocus]="true"
                [class.cursor-pointer]="!isOpen()"
                [placeholder]="placeholder() | transloco"
                [(ngModel)]="searchValue"
                (click)="onInputClick($event)"
                (keyup)="filterOptions()" />
        }
        <div class="flex flex-row items-center">
            @if (selectedOption() && !isOpen()) {
                <fa-icon
                    class="text-outline"
                    size="lg"
                    [fixedWidth]="true"
                    [icon]="['fas', 'xmark']"
                    (click)="resetSelection($event)" />
            }
            <fa-icon
                class="transition duration-200 ease-in-out"
                size="sm"
                [class.expanded]="isOpen()"
                [fixedWidth]="true"
                [icon]="['fas', 'caret-down']" />
        </div>
    </div>
    @if (isOpen()) {
        <div
            #selectOptions
            class="select-options"
            [ngStyle]="{ 'width.px': dropdownWidth }">
            @if (!options().length) {
                <div class="px-2 py-1">
                    <p class="!m-0 text-outline text-base">{{ 'noSearchResults' | transloco }}</p>
                </div>
            }

            <div class="overflow-y-auto max-h-36">
                @for (option of options(); track option) {
                    <div
                        #selectOptionElement
                        class="option px-2 py-1 cursor-pointer flex flex-row items-center transition duration-100 ease-in-out"
                        [class.active]="isOptionSelected(option)"
                        (click)="toggleOption(option)">
                        <p class="truncated !m-0 text-base">
                            @for (
                                labelWithStyle of option.labelsWithStyle;
                                track labelWithStyle.label;
                                let last = $last
                            ) {
                                <span
                                    class="px-2 rounded-xl"
                                    [style]="{
                                        'background-color': labelWithStyle.color,
                                        border: !!labelWithStyle.color ? '1px solid #000000' : '',
                                        'border-radius': '0.75rem',
                                        color: labelWithStyle.font,
                                    }">
                                    {{ labelWithStyle.label }}</span
                                >
                                @if (!last) {
                                    |
                                }
                            }
                        </p>
                    </div>
                }
            </div>
            @if (bottomOption()) {
                <div class="p-2">
                    <ng-container *ngTemplateOutlet="bottomOption() ?? null" />
                </div>
            }
        </div>
    }
</div>
